export default "__VITE_PUBLIC_ASSET__9c2a8524__"